import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap"; 
import * as apiUrl from "../../apiUrl";
import { Link } from "react-router-dom";

function HomeProjects() {
  const [HomeProjects, setHomeProjects] = useState([]);

  useEffect(() => {
    const fetchHomeProject = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/home/featured-project-section`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setHomeProjects(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchHomeProject();
  }, []);

  return (

    <div className="home-projects-sec">
      <Container fluid>
        <Row className="banner-text-center">
          <Col md={12}>
            <div className="heading-div">
              <h2 className="common-head darkGrey" data-aos="fade-up">
                {HomeProjects.section_title}
              </h2>
            </div>
          </Col>
        </Row>
      </Container>
      <Container fluid>
        <div className="home-projects-sec-div">
          <Row className="banner-text-center">
            <Col md={7}>
              <div className="project-img-card" data-aos="fade-right">
                <Link
                  to={`/properties${HomeProjects.large_project_card_link}`}
                >

                  {" "}
                  <img
                    src={
                      apiUrl.apiUrl +
                      `/` +
                      HomeProjects.large_project_card_image
                    }
                    className="img-fluid"
                    alt="Real Estate Company Dubai"
                  />{" "}

                  <div className="project-img-desc">
                    <h3 className="goldenColor luxury-font">
                      {HomeProjects.large_project_card_title}
                    </h3>
                    <p>{HomeProjects.large_project_card_description}</p>
                  </div>
                </Link>
              </div>
            </Col>
            <Col md={4}>
              <div className="project-img-sm-card" data-aos="fade-left">
                <Link
                  to={`/properties${HomeProjects.first_small_project_card_link}`}
                >

                  {" "}
                  <img
                    src={
                      apiUrl.apiUrl +
                      `/` +
                      HomeProjects.first_small_project_card_image
                    }
                    className="img-fluid"
                    alt="Real Estate Developer Dubai"
                  />

                  <div className="project-img-desc">
                    <h3 className="goldenColor luxury-font">
                      {HomeProjects.first_small_project_card_title}
                    </h3>
                    <p>{HomeProjects.first_small_project_card_description}</p>
                  </div>
                </Link>
              </div>

              <div className="project-img-sm-card" data-aos="fade-left">
                <Link
                  to={`/properties${HomeProjects.second_small_project_card_link}`}
                >
                  {" "}
                  <img
                    src={
                      apiUrl.apiUrl +
                      `/` +
                      HomeProjects.second_small_project_card_image
                    }
                    className="img-fluid"
                    alt="Top real estate companies in Dubai"
                  />
                  <div className="project-img-desc">
                    <h3 className="goldenColor luxury-font">
                      {HomeProjects.second_small_project_card_title}
                    </h3>
                    <p>
                      {HomeProjects.second_small_project_card_description}
                    </p>
                  </div>
                </Link>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </div>

  );
}

export default HomeProjects;
